/**
 * An "action" in this context is any DOM element/tree that
 * has event handlers for triggering some type of action--creating,
 * editing, deleting data, etc. The Action component wraps the given
 * DOM element/tree and runs permissions checks before rendering anything.
 * If the checks don't pass, Action renders null (or props.alt).
 */

import PropTypes from 'prop-types';

const Action = ({ custom, predicates, alt, children }) => {

  // First, check predicates (if any).
  const pass = predicates.reduce((val, f) => val ? f() : val, true);
  if (!pass) {
    return alt;
  }

  // If custom then don't check anything beyond the predicates.
  if (custom) {
    return children;
  }

  // Now check linkSharingData and permissions.

  /**
   * @type {LinkSharingProperties}
   */
  const { linkSharingData } = window.gs;

  if (linkSharingData) {
    // If readonly, don't render anything.
    if (linkSharingData.isReadOnlyLink()) {
      return alt;
    }

    // TODO: more linkSharingData checks?
  }

  // TODO: check other permissions?

  return children;
};

Action.propTypes = {
  custom: PropTypes.bool,
  predicates: PropTypes.arrayOf(PropTypes.func),
  alt: PropTypes.node
};

Action.defaultProps = {
  custom: false,
  predicates: [],
  alt: null
};

export default Action;
